import { render, staticRenderFns } from "./InfectionControlPrevention.vue?vue&type=template&id=05037b04&"
import script from "./InfectionControlPrevention.vue?vue&type=script&lang=js&"
export * from "./InfectionControlPrevention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports